// export const API_BASE_URL = 'http://sipth0cdh0s72mjo8bt.dev.syzkcf.com'
// export const API_BASE_URL = 'http://bwwp-scpebcf8zy7zy99b.bluewisdom.com.cn/'
// export const API_BASE_URL = 'http://bwwp-scpebcf8zy7zy99b.bluewisdomsip.com/'
// export const API_BASE_URL = 'http://hysip-local.bluewisdom.com'
// export const API_BASE_URL = 'http://192.168.1.186:8080'
// export const API_BASE_URL = 'http://localhost:8080'
// export const API_BASE_URL = 'http://192.168.1.191:12004'
// export const API_BASE_URL = 'http://bwwp-bw.bluewisdom.com.cn/'
// export const API_BASE_URL = 'http://bwwp.bluewisdom.com.cn/' // 测试
export const API_BASE_URL = ''
// export const API_BASE_URL = 'http://bwwp-cr.bluewisdom.com.cn/'


// WEBPACK FOOTER //
// ./src/common/utils/commonUrl.js